import { createSlice } from "@reduxjs/toolkit";
import {
  deleteDistrict,
  getDistrict,
  undoDeleteDistrict,
} from "./district.api";

const surnameSlice = createSlice({
  name: "district",
  initialState: {
    district: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDistrict.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getDistrict.fulfilled, (state, action) => {
      state.loading = false;
      state.district = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getDistrict.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteDistrict.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteDistrict.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.district.data) {
        state.district.data = state.district.data.filter((district) => {
          return district._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.district.data is not an array:",
          state.district.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteDistrict.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteDistrict.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteDistrict.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.district.data) {
        state.district.data = state.district.data.filter((district) => {
          return district._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.district.data is not an array:",
          state.district.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteDistrict.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = surnameSlice.actions;
export default surnameSlice.reducer;
